// extracted by mini-css-extract-plugin
module.exports = {"higpp-l-login-box-choose-session":"ChooseSession_higpp-l-login-box-choose-session__1KvOC"};